import React from 'react';
import Map from 'components/Map';
import {
  Grid,
  Typography,
  Paper,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(() => ({
  dialogWrapper: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    right: '1rem',
    top: '1rem',
    maxWidth: '40%',
  },
  siteImage: {
    width: '100%',
    height: 'auto',
  },
  siteImageWrapper: {
    marginTop: '1rem',
    height: '50%',
    display: 'block',
  },
}));

const App = () => {
  const classes = useStyles();
  const [dialogue, setDialogue] = React.useState(undefined); // product object
  const [siteImage, setSiteImage] = React.useState(undefined); // image

  return (
    <Box width={'100vw'} height={'100vh'}>
      <Map
        setDialogue={setDialogue}
        dialogue={dialogue}
        setSiteImage={setSiteImage}
      />
      <Box className={classes.dialogWrapper}>
        {dialogue && (
          <Paper>
            <DialogTitle id="alert-dialog-title" style={{ padding: 0 }}>
              <Grid container justify="space-between" alignItems="center">
                <Box display="flex" alignItems="center">
                  <img
                    src={dialogue.icon}
                    alt="country icon"
                    style={{
                      width: 32,
                      height: 32,
                    }}
                  />
                  <Typography variant={'h5'} style={{ paddingLeft: '1rem' }}>
                    {dialogue.title}
                  </Typography>
                </Box>
                <CloseIcon
                  onClick={() => setDialogue(undefined)}
                  style={{ cursor: 'pointer' }}
                />
              </Grid>
            </DialogTitle>
            <DialogContent style={{ padding: 16 }}>
              <Typography variant="body2">
                The following user organisations from {dialogue.title} have been
                invited to participate in this project:
              </Typography>
              <ul style={{ paddingInlineStart: 24 }}>
                {dialogue.partners.map((partner, i) => (
                  <li key={i}>
                    <Typography variant="body2">{partner}</Typography>
                  </li>
                ))}
              </ul>
            </DialogContent>
          </Paper>
        )}
        {siteImage !== undefined && (
          <Dialog
            open={siteImage !== undefined}
            onClose={() => setSiteImage(undefined)}
          >
            <DialogTitle id="alert-dialog-title" style={{ padding: 0 }}>
              <Grid container justify="space-between" alignItems="center">
                <Box display="flex" alignItems="center">
                  <Typography variant={'h5'} style={{ paddingLeft: '1rem' }}>
                    {'Site preview'}
                  </Typography>
                </Box>
                <CloseIcon
                  onClick={() => setSiteImage(undefined)}
                  style={{ cursor: 'pointer' }}
                />
              </Grid>
            </DialogTitle>
            <DialogContent style={{ padding: 16 }}>
              <img
                className={classes.siteImage}
                src={siteImage}
                alt={'site-example'}
              />
            </DialogContent>
          </Dialog>
        )}
      </Box>
    </Box>
  );
};

export default App;
